import { render } from "./globalLogin.vue?vue&type=template&id=18e9811e&scoped=true"
import script from "./globalLogin.vue?vue&type=script&lang=js"
export * from "./globalLogin.vue?vue&type=script&lang=js"

import "./globalLogin.vue?vue&type=style&index=0&id=18e9811e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e9811e"]])

export default __exports__